import { render, staticRenderFns } from "./HeaderProfile.vue?vue&type=template&id=0e349e7e&"
import script from "./HeaderProfile.vue?vue&type=script&lang=js&"
export * from "./HeaderProfile.vue?vue&type=script&lang=js&"
import style0 from "./HeaderProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports